export default __webpack_public_path__ + "static/takemyexam-1fe3929d04a564baf9bf9bb99df44895.webp";